import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Radio } from "antd";
import { useMemo } from "react";
import { EUserRole, TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useServiceCdnState } from "../../../../../hooks/service/useServiceCdnState.js";
import { useTranslation } from "../../../../../others/i18n.js";
import { getFieldNameTranslated } from "../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper } from "../formFieldVisibilityWrapper.js";
function FormFieldTemplateIsHidden() {
    const { t } = useTranslation();
    const options = useMemo(()=>[
            {
                label: t("Visible"),
                value: false
            },
            {
                label: t("Hidden"),
                value: true
            }
        ], [
        t
    ]);
    const cdnState = useServiceCdnState();
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: TemplateMetaDataField.IsHidden,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: getFieldNameTranslated(TemplateMetaDataField.IsHidden, t),
            extra: t("Define if this template is visible to website operators in overview. A sample for a hidden template could be a base template, which itself is not useful to display."),
            shouldUpdate: (prev, next)=>prev !== next,
            required: true,
            children: ()=>{
                return /*#__PURE__*/ _jsx(Form.Item, {
                    name: TemplateMetaDataField.IsHidden,
                    rules: [
                        {
                            required: true,
                            message: t("Please choose visibility.")
                        }
                    ],
                    noStyle: true,
                    children: /*#__PURE__*/ _jsx(Radio.Group, {
                        disabled: cdnState !== "disabled",
                        options: options,
                        optionType: "button",
                        buttonStyle: "solid"
                    })
                });
            }
        })
    });
}
export { FormFieldTemplateIsHidden };
